import React, { useState } from 'react';
import { Order } from '../types';

interface OrdersTabProps {
  orders: Order[];
  onViewDetails: (order: Order) => void;
  onUpdateStatus: (orderId: string, newStatus: string) => void;
}

export const OrdersTab: React.FC<OrdersTabProps> = ({ orders, onViewDetails, onUpdateStatus }) => {
  const [statusFilter, setStatusFilter] = useState('all');

  const filteredOrders = orders.filter(order =>
    statusFilter === 'all' || order.status === statusFilter
  );

  const getStatusClass = (status: string) => {
    const statusClasses = {
      'pending': 'status-pending',
      'assigned': 'status-assigned',
      'planted': 'status-planted',
      'completed': 'status-completed'
    };
    return statusClasses[status as keyof typeof statusClasses] || '';
  };

  return (
    <div style={{
      background: 'white',
      padding: '2rem',
      borderRadius: '15px',
      boxShadow: '0 5px 20px rgba(0,0,0,0.1)'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '1.5rem'
      }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#333', margin: 0 }}>
          {'Órdenes de Plantación de Árboles'}
        </h2>
        <span style={{ color: '#666' }}>
          {filteredOrders.length} {'órdenes'}
        </span>
      </div>

      {/* Filters */}
      <div style={{ display: 'flex', gap: '1rem', marginBottom: '2rem' }}>
        <select
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
          style={{
            padding: '8px 12px',
            border: '1px solid #ddd',
            borderRadius: '5px',
            background: 'white'
          }}
        >
          <option value="all">{'Todas las Órdenes'}</option>
          <option value="pending">{'Pendiente'}</option>
          <option value="assigned">{'Asignado'}</option>
          <option value="planted">{'Plantado'}</option>
          <option value="completed">{'Completado'}</option>
        </select>
      </div>

      {/* Orders List */}
      <div>
        {filteredOrders.length === 0 ? (
          <p style={{ textAlign: 'center', color: '#666', padding: '2rem' }}>
            {'No se encontraron órdenes'}
          </p>
        ) : (
          filteredOrders.map((order) => (
            <div
              key={order._id}
              style={{
                border: '1px solid #eee',
                padding: '1.5rem',
                marginBottom: '1rem',
                borderRadius: '10px',
                transition: 'box-shadow 0.3s ease'
              }}
            >
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '1rem'
              }}>
                <span style={{ fontWeight: 'bold', color: '#333' }}>
                  Order #{order._id.slice(-6)}
                </span>
                <span className={`order-status ${getStatusClass(order.status)}`} style={{
                  padding: '5px 15px',
                  borderRadius: '20px',
                  fontSize: '0.9rem',
                  fontWeight: '600'
                }}>
                  {({'pending':'Pendiente','assigned':'Asignado','planted':'Plantado','completed':'Completado'} as Record<string,string>)[order.status] || order.status}
                </span>
              </div>

              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: '1rem',
                marginBottom: '1rem'
              }}>
                <div>
                  <div style={{ fontWeight: '600', color: '#666', fontSize: '0.9rem' }}>
                    {'Cliente'}
                  </div>
                  <div style={{ color: '#333', marginTop: '0.2rem' }}>
                    {order.customerEmail}
                  </div>
                </div>

                <div>
                  <div style={{ fontWeight: '600', color: '#666', fontSize: '0.9rem' }}>
                    {'Árboles'}
                  </div>
                  <div style={{ color: '#333', marginTop: '0.2rem' }}>
                    {order.trees || order.treesOrdered || 0} trees
                  </div>
                </div>

                <div>
                  <div style={{ fontWeight: '600', color: '#666', fontSize: '0.9rem' }}>
                    {'Cantidad'}
                  </div>
                  <div style={{ color: '#333', marginTop: '0.2rem' }}>
                    {order.currency || 'USD'} {((order.totalAmount || order.amount || 0) / 100).toFixed(2)}
                  </div>
                </div>

                <div>
                  <div style={{ fontWeight: '600', color: '#666', fontSize: '0.9rem' }}>
                    {'Fecha'}
                  </div>
                  <div style={{ color: '#333', marginTop: '0.2rem' }}>
                    {new Date(order.createdAt).toLocaleDateString()}
                  </div>
                </div>
              </div>

              {/* Order Actions */}
              <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem', flexWrap: 'wrap' }}>
                <button
                  onClick={() => onViewDetails(order)}
                  style={{
                    padding: '8px 16px',
                    background: '#6c757d',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    fontSize: '0.9rem'
                  }}
                >
                  {'Ver Detalles'}
                </button>
                <select
                  value={order.status}
                  onChange={(e) => onUpdateStatus(order._id, e.target.value)}
                  style={{
                    padding: '8px 12px',
                    border: '2px solid #228B22',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    fontSize: '0.9rem',
                    fontWeight: '600',
                    color: '#333',
                    background: '#fff'
                  }}
                >
                  <option value="pending">{'Pendiente'}</option>
                  <option value="assigned">{'Asignado'}</option>
                  <option value="planted">{'Plantado'}</option>
                  <option value="completed">{'Completado'}</option>
                </select>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};
